export default __webpack_public_path__ + "static/media/10.9240c973.png";